import React from "react";

export default function AWS_Aurora() {
  return (
    <div>
      <h1>What is AWS Aurora</h1>
      <p>
        Route: <code>/aws/aurora</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
